import { motion, useReducedMotion } from 'framer-motion';

// Hoisted animation constants — stable object identity across renders.
const EASE_HERITAGE = [0.22, 1, 0.36, 1];
const RULE_INITIAL_REDUCED = { opacity: 1 };
const RULE_INITIAL = { opacity: 0 };
const RULE_WHILE_IN_VIEW = { opacity: 1 };
const RULE_VIEWPORT = { once: true, amount: 0.6 };

// Heritage divider: thin 1px stone hairline, quiet fade-in on scroll. No glow, no dot.
export const YellowRule = ({ className = '', delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={`rule-gradient ${className}`}
      initial={reduce ? RULE_INITIAL_REDUCED : RULE_INITIAL}
      whileInView={RULE_WHILE_IN_VIEW}
      viewport={RULE_VIEWPORT}
      transition={{ duration: 0.9, delay, ease: EASE_HERITAGE }}
    />
  );
};

export default YellowRule;
